// exportLabs.ts
import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'
import moment from 'moment'

export interface PersonnaelRow {
    name: string
    phone: string
    positionName: string
    roleName: string
    branchName: string
    status: string
    updatedBy: string
    updatedAt: string
}

export interface PersonnaelReport {
    title: string
    statusFilter: string
    rows: PersonnaelRow[]
    t: any
}

export async function exportPersonnaelToExcel(report: PersonnaelReport) {
    const wb = new ExcelJS.Workbook()
    const ws = wb.addWorksheet(report.title, {
        pageSetup: { orientation: 'portrait' }
    })
    ws.properties.defaultRowHeight = 20

    ws.columns = [
        { header: '#', width: 6 },
        { header: report.t('PERSONNEL.TABLE.CELL.PERSONNEL_NAME'), width: 30 },
        { header: report.t('PERSONNEL.TABLE.CELL.PERSONNEL_PHONE'), width: 20 },
        { header: report.t('PERSONNEL.TABLE.CELL.PERSONNEL_POSITION'), width: 20 },
        { header: report.t('PERSONNEL.TABLE.CELL.PERSONNEL_ROLE'), width: 20 },
        { header: report.t('PERSONNEL.TABLE.CELL.PERSONNEL_BRANCH'), width: 50 },
        { header: report.t('USER.TABLE.CELL.STATUS'), width: 14 },
        { header: report.t('USER.TABLE.CELL.UPDATED_BY'), width: 30 }
    ]

    let row = 1

    ws.mergeCells(row, 1, row, 8)
    ws.getCell(row, 1).value = report.title
    ws.getCell(row, 1).font = { size: 16, bold: true }
    ws.getCell(row, 1).alignment = { horizontal: 'center', vertical: 'middle' }
    row += 2

    ws.mergeCells(row, 1, row, 8)
    ws.getCell(row, 1).value = report.statusFilter
    ws.getCell(row, 1).font = { size: 12 }
    ws.getCell(row, 1).alignment = { horizontal: 'left', vertical: 'middle' }
    row += 2

    const headerRow = ws.addRow(ws.columns.map(col => col.header as string))
    headerRow.height = 24
    headerRow.font = { bold: true }
    headerRow.alignment = { horizontal: 'center', vertical: 'middle' }
    headerRow.eachCell(cell => {
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFFFFFFF' }
        }
        cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
        }
    })
    row++

    if (!report.rows || report.rows.length === 0) {
        const noDataRow = ws.addRow([report.t('REPORT.TITLE.NO_DATA')])
        ws.mergeCells(noDataRow.number, 1, noDataRow.number, ws.columns.length)
        noDataRow.font = { italic: true, color: { argb: 'FF000000' } }
        noDataRow.alignment = { horizontal: 'center' }
        const buf = await wb.xlsx.writeBuffer()
        saveAs(
            new Blob([buf]),
            `${report.title}_${moment().format('YYYYMMDD')}.xlsx`
        )
        return
    }
    // 5) Data rows
    report.rows.forEach((r, i) => {
        const excelRow = ws.addRow([
            i + 1,
            r.name,
            r.phone,
            r.positionName,
            r.roleName,
            r.branchName,
            r.status,
            `${r.updatedBy} ${r.updatedAt}`
        ])
        excelRow.height = 20
        excelRow.eachCell((cell, col) => {
            // border รอบทุก cell
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            }
            switch (col) {
                case 1:
                case 7:
                case 8:
                    cell.alignment = { horizontal: 'center', vertical: 'middle' }
                    break
                default:
                    cell.alignment = { horizontal: 'left', vertical: 'middle' }
            }
        })
    })

    const buf = await wb.xlsx.writeBuffer()
    saveAs(
        new Blob([buf]),
        `${report.title}_${moment().format('YYYYMMDD')}.xlsx`
    )
}
